import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfigModule } from '@klickdata/core/config';
import { HttpModule } from '@klickdata/core/http';

@NgModule({
    imports: [CommonModule, HttpModule, ConfigModule],
})
export class NotificationModule {}
